module.exports = __webpack_public_path__ + "static/media/search_icon.443d8988.svg";